const Loading = () => (
  <blockquote className="border-l-4 border-green-500 italic my-8 pl-8 md:pl-12">
    Loading data...
  </blockquote>
);

export default Loading;